<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink, useRoute } from 'vue-router'
import { guideArticle, guideGroups } from '@motexa/user-guide'
import GuideBody from '@motexa/user-guide/GuideBody.vue'
import '@motexa/user-guide/style.css'
import { useSiteLocale } from '../composables/useSiteLocale'
const route = useRoute()
const { currentLocale } = useSiteLocale()
const slug = computed(() => String(route.params.slug ?? ''))
const article = computed(() => guideArticle(slug.value, currentLocale.value, '/docs'))
const groups = computed(() => guideGroups(currentLocale.value))
</script>

<template>
  <div class="simple-page guide-surface website-guide guide-detail">
    <RouterLink class="guide-site-back" to="/docs">← {{ currentLocale === 'zh-CN' ? '使用教程' : 'User guide' }}</RouterLink>
    <div class="guide-detail-layout">
      <nav class="guide-category-nav" :aria-label="currentLocale === 'zh-CN' ? '教程分类' : 'Guide categories'">
        <section v-for="group in groups" :key="group.id">
          <h2>{{ group.title }}</h2>
          <RouterLink v-for="item in group.articles" :key="item.slug" :to="`/docs/${item.slug}`" :aria-current="item.slug === slug ? 'page' : undefined">{{ item.title }}</RouterLink>
        </section>
      </nav>
      <div class="guide-detail-content">
        <header class="guide-site-hero">
          <h1>{{ article?.title ?? (currentLocale === 'zh-CN' ? '未找到教程' : 'Guide not found') }}</h1>
          <p v-if="article">{{ article.summary }}</p>
        </header>
        <GuideBody :slug="slug" :locale="currentLocale" base="/docs" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.guide-detail { max-width: 1440px; }
.guide-site-back { display: inline-block; color: var(--guide-link); font-size: .88rem; margin-bottom: 2rem; }
.guide-detail-layout { display: grid; grid-template-columns: 180px minmax(0, 1fr); gap: 3rem; }
.guide-category-nav { position: sticky; top: 7rem; align-self: start; display: grid; gap: 1.7rem; }
.guide-category-nav h2 { font-size: .78rem; color: var(--guide-muted); font-weight: 600; margin: 0 0 .6rem; }
.guide-category-nav a { display: block; font-size: .85rem; padding: .6rem .75rem; margin-inline-start: -.75rem; border-radius: 8px; line-height: 1.6; overflow-wrap: anywhere; }
.guide-category-nav a[aria-current='page'] { color: var(--guide-link); background: var(--guide-fill); }
.guide-detail-content { min-width: 0; }
@media (max-width: 850px) { .guide-detail-layout { grid-template-columns: minmax(0, 1fr); } .guide-category-nav { display: none; } }
</style>
